function loadPopupStyle(){
    const popupContent = document.querySelector('.popup__content-inner');
    const hasImage = popupContent?.querySelector('.popup__image');
    const isMobile = window.innerWidth < 768;

    if (popupContent && hasImage && isMobile) {
      popupContent.style.display = 'flex';
      popupContent.style.flexDirection = 'column';
      popupContent.style.minHeight = '420px';
      popupContent.style.justifyContent = 'space-between';
      popupContent.style.alignItems = 'center';
      
    }
}
function getSelectedCountry() {
  return Shopify?.country || null;
}

async function getCartTotal() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    return cart.total_price / 100;
  } catch (err) {
    console.error("Failed to fetch cart:", err);
    return 0;
  }
}

function showPopup() {
  const popup = document.querySelector('[data-id="popup_jKqD4j"]');
  popup.parentElement.parentElement.style.display = "block";
  popup.classList.add("visible");
}

function hidePopup() {
  const popup = document.querySelector('[data-id="popup_jKqD4j"]');
  popup.parentElement.parentElement.style.display = "none";
  popup.classList.remove("visible");
}

async function evaluatePopupLogic() {
  if( !window.location.pathname.endsWith("/cart")){
    hidePopup()
    return;
  }
  await new Promise((resolve) => setTimeout(resolve, 2000));  
  const country = getSelectedCountry();
  if (country !== "KW") {
    hidePopup();
    return;
  }

  const cartTotal = await getCartTotal();
  if (cartTotal >= 40) {
    showPopup();
  } else {
    hidePopup();
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  loadPopupStyle();
  if ( !window.location.pathname.endsWith("/cart")) {
     hidePopup();
    return;
  }

  hidePopup(); // Prevent flicker
  await evaluatePopupLogic(); // Initial check
});
